const flights = {
  flight: "Volo", // translated
  flights: "voli", // translated
  originDepartureDate: "Partenza", // translated
  destinationDepartureDate: "Ritorno", // translated
  outbound: "In uscita", // translated
  inbound: "In entrata", // translated
  travelTime: "Tempo di viaggio", // translated
  selected: "selezionato", // translated
  select: "Selezionare", // translated
  airline: "Compagnia aerea", // translated
  directFlight: "Volo diretto", // translated
  baggage: "Bagaglio", // translated
  stops: "Fermate", // translated
  nonStop: "Non stop", // translated
  oneStopMax: "Una fermata al massimo", // translated
  twoStopsMax: "Due fermate al massimo", // translated
  anyStops: "Con eventuali fermate", // translated
  smallBaggage: "Piccolo bagaglio", // translated
  bigBaggage: "Grande bagaglio", // translated
  smallAndBigBaggage: "Bagagli piccoli e grandi", // translated
  outboundStops: "Fermate in uscita", // translated
  inboundStops: "Fermate in entrata", // translated
  selectAirline: "Seleziona compagnia aerea", // translated
  baggageOption: "Opzione bagaglio", // translated
  outboundDepartureAfter: "Partenza in andata dopo", // translated
  outboundArrivalAfter: "Arrivo in uscita dopo", // translated
  inboundDepartureAfter: "Partenza in entrata dopo", // translated
  inboundArrivalTimeAfter: "Arrivo in entrata dopo", // translated
  flightClass: "Classe di volo", // translated
  outboundDepAfter: "Partenza dopo", // translated
  outboundArrivalAfrer: "Arrivo in uscita dopo", // translated
  inboundDepAfter: "In partenza dopo", // translated
  inboundArrivalAfter: "In arrivo dopo", // translated
  airlines: "Compagnia aerea(e)", // translated
  lessThan: "Meno di", // translated
  layover: "Sosta", // translated
  duration: "Durata", // translated
  economy: "Economia", // translated
  business: "Attività commerciale", // translated
  with: "Con", // translated
  without: "Senza", // translated
  twoOrMore: "Due o più", // translated
  departure: "Partenza", // translated
  return: "Ritorno", // translated
  submit: "Invia", // translated
  priceLessThan: "Prezzo inferiore a", // translated
  durationLessThan: "Durata inferiore a", // translated
  layoverLessThan: "Sosta inferiore a", // translated
  noLayover: "Nessuna sosta", // translated
  durationLowestFirst: "Durata (prima la più bassa)", // translated
  durationHighestFirst: "Durata (prima la più alta)", // translated
  idType: "Tipo di documento d'identità", // translated
  idPassportCode: "Codice ID/passaporto", // translated
  expirationDate: "Data di scadenza", // translated
  frequentFlyerNumber: "Numero del frequent flyer", // translated
  frequentFlyerAirline: "Compagnia aerea Frequent Flyer", // translated
  dateOfBirth: "Data di nascita", // translated
  infant: "Infante", // translated
  phone: "Telefono", // translated
  title: "Titolo", // translated
  noLuggageIncluded: "Nessun bagaglio incluso", // translated
  includesLuggage: "Include bagagli", // translated
  outboundFlight: "Volo di andata", // translated
  inboundFlight: "Volo in arrivo", // translated
  flightNumber: "Numero di volo", // translated
  flightNumbers: "Numeri di volo", // translated
  cabinClassType: "Tipo di classe di cabina", // translated
  aircraftType: "Tipo di aereo", // translated
  airlineName: "Nome della compagnia aerea", // translated
  no: "NO", // translated
  yes: "SÌ", // translated
  anyFlights: "Eventuali voli", // translated
  oneStop: "Una fermata", // translated
  direct: "Diretto", // translated
  directFlights: "Voli diretti", // translated
  all: "Tutto", // translated
  first: "Primo", // translated
  premiumEconomy: "Prem. Economia", // translated
  withBaggageOnly: "Solo con bagaglio", // translated
  oneWay: "Senso Unico", // translated
  roundTrip: "Andata e ritorno", // translated
  withBaggage: "Con Bagaglio", // translated
  noBaggage: "Nessun bagaglio", // translated
  requiredFields: "Campi richiesti", // translated
  nonRequiredFields: "Campi non obbligatori", // translated
  cabinClass: "Classe cabina", // translated
  brandName: "Marchio", // translated
  performNewSearch: "Esegui una nuova ricerca", // translated
  outboundDeparture: "Partenza in andata", // translated
  inboundDeparture: "Partenza in entrata", // translated
  created: "Creato", // translated
  freeCancellationAvailable: "Cancellazione gratuita disponibile", // translated
  freeCancellationDeadline: "Scadenza per la cancellazione gratuita", // translated
  externalReference: "Riferimento esterno", // translated
  outboundflightNumber: "Numero del volo di andata", // translated
  inboundflightNumber: "Numero del volo in arrivo", // translated
  arrival: "Arrivo", // translated
};

export default flights;
